export default __webpack_public_path__ + "static/media/CIA-Fidelity-Computer-Crime-Claim-Form.aab9754f.pdf";